module.exports = __webpack_public_path__ + "img/vignettes-asso_0003_enfants-du-mekong.7220eda9.jpg";